export const isAndroid = /(android)/i.test(navigator.userAgent);
export const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

export const isPortrait = () => window.innerWidth < window.innerHeight;
export const isLandscape = () => window.innerHeight < window.innerWidth;

export const isTablet =
  /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
    navigator.userAgent.toLowerCase()
  );
